'use client';
import { authHref, safeAuthReturn } from '@/shared/lib/auth-return';

import { useActionState, useEffect } from 'react';

import { useToast } from '@/features/toast';
import { Button, MailIcon, TextFiled } from '@/shared';

import { restoreAction } from '../action';

type RestoreFormProps = {
	redirectPath?: string;
	action?: typeof restoreAction;
	onSuccess?: (email: string) => void;
};

export function RestoreForm({
	action = restoreAction,
	onSuccess,
	redirectPath,
}: RestoreFormProps = {}) {
	const { addToast } = useToast();
	const [state, formAction, pending] = useActionState(action, {});

	useEffect(() => {
		if (state.message) {
			addToast('Ошибка', state.message, 'error');
		}
	}, [addToast, state]);

	useEffect(() => {
		if (state.success) {
			onSuccess?.((state.formData?.get('email') as string) || '');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state.success]);

	return (
		<form
			className="flex flex-1 flex-col gap-8 md:flex-grow-0"
			action={formAction}
		>
			<input
				type="hidden"
				name="redirect"
				value={safeAuthReturn(redirectPath) ?? ''}
			/>
			<fieldset className="mb-auto space-y-3">
				<TextFiled
					type="email"
					name="email"
					placeholder="E-mail"
					icon={<MailIcon className="size-6" />}
					defaultValue={(state?.formData?.get('email') as string) || ''}
					invalid={!!state?.errors?.email}
					hint={state?.errors?.email?.reduce((_, err) => err, '')}
					size="lg"
					autoComplete="email"
					required
				/>
			</fieldset>
			<Button type="submit" loading={pending} block>
				Далее
			</Button>
		</form>
	);
}
